import $ from "jquery";
import Cookies from "js-cookie";

import morningstarFunctions from "./morningstar-functions";

const { elementBindings, configuration, cssConfig, getTokenConfig, getFreshToken, handleMorningStarError } =
  morningstarFunctions;

function init(): void {
  const $morningstarElement = $(".js-morningstar-investment-compare");

  if (!$morningstarElement.length) {
    return;
  }

  const { tokenApiUrl, componentId, namespace, environment } = $morningstarElement[0].dataset;

  function loadScreener(token: string) {
    const appConfig = {
      components: {
        ecInvestmentCompare: {
          type: componentId,
          settings: {
            idType: "msid",
            securityIds: "EUCA000637|EUCA000857|EUCA000765",
          },
        },
      },
    };
    const settings = {
      angular: elementBindings(componentId),
      lazy: {
        bundlesToDownload: {
          ecInvestmentCompare: true,
        },
      },
      configuration: configuration(namespace, environment, appConfig),
      apiTokens: getTokenConfig(token),
      css: cssConfig,
    };

    window["morningstar"].loader
      .load(settings)
      .then(function () {
        // (manifest)
        window.console.log("Component loaded successfully");
        const container = document.getElementById("ecInvestmentCompare-container");
        window["morningstar"].loader.lazyLoad(
          container,
          "investment-compare-container",
          "ec-Investment-Compare",
          "ecInvestmentCompare"
        );
        // .then(function () {});
      })
      .catch(function (error: any) {
        handleMorningStarError(error, tokenApiUrl, loadScreener);
      });
  }

  const token = Cookies.get("MSToken");
  if (token) {
    loadScreener(token);
  } else {
    getFreshToken(tokenApiUrl, loadScreener);
  }
}

export default { init };
